import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension/logOnly';
import thunk from "redux-thunk";
import { persistStore } from 'redux-persist';
import reducer from "./reducer";

const devTools =
  process.env.NODE_ENV === "production"
    ? applyMiddleware(thunk)
    : composeWithDevTools(applyMiddleware(thunk));

const store = createStore(reducer, devTools);

export const persistor = persistStore(store);

export default store;
